import type { MachineEventSummary, LineManualEntry } from "@/features/lines/hooks";

export type UnifiedItem =
  | {
      kind: "event";
      _at: string;
      id: string;
      event: MachineEventSummary;
    }
  | {
      kind: "manual-entry";
      _at: string;
      id: string;
      entry: LineManualEntry;
    };

export const OVERLAY_LIMIT = 200;

export function fmtTs(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
